import { motion } from 'framer-motion';
import { testimonials } from '../../../mocks/agents';

export default function Testimonials() {
  return (
    <section className="py-32 bg-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyber-blue/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyber-purple/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-5xl lg:text-6xl font-display font-bold text-white mb-6">
            Ils Ont Transformé Leur Business
          </h2>
          <p className="text-xl text-gray-400 font-body max-w-3xl mx-auto">
            Découvrez comment nos clients ont multiplié leurs performances grâce aux Agents IA
          </p>
        </motion.div>

        <div className="space-y-32">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={testimonial.id}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className={`grid lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              {/* Quote Side */}
              <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="relative">
                  {/* Quote Icon */}
                  <div className="absolute -top-6 -left-6 w-16 h-16 flex items-center justify-center bg-gradient-to-br from-cyber-blue to-cyber-purple rounded-2xl opacity-20">
                    <i className="ri-double-quotes-l text-3xl text-white"></i>
                  </div>

                  {/* Quote Text */}
                  <blockquote className="relative text-2xl lg:text-3xl font-display text-white leading-relaxed mb-8">
                    "{testimonial.quote}"
                  </blockquote>

                  {/* Author Info */}
                  <div className="flex items-center gap-4">
                    <img
                      src={testimonial.logo}
                      alt={testimonial.company}
                      width="60"
                      height="60"
                      loading="lazy"
                      decoding="async"
                      className="w-15 h-15 rounded-xl object-cover"
                    />
                    <div>
                      <div className="text-lg font-display font-bold text-white">
                        {testimonial.author}
                      </div>
                      <div className="text-sm text-gray-400 font-body">
                        {testimonial.role}
                      </div>
                      <div className="text-sm text-cyber-blue font-body font-semibold">
                        {testimonial.company}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Image Side */}
              <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                <div className="relative rounded-3xl overflow-hidden">
                  <img
                    src={
                      testimonial.author === "Sophie Mercier"
                      ? "https://public.readdy.ai/ai/img_res/342738375e0a4f010788951adb9f9b2d.jpg"
                      : testimonial.author === "Amélie Laurent"
                      ? "https://readdy.ai/api/search-image?query=elegant-professional-businesswoman-with-shoulder-length-blonde-hair-wearing-stylish-charcoal-blazer-confident-warm-smile-modern-corporate-office-soft-natural-lighting-sophisticated-HR-director-portrait-contemporary-business-attire-friendly-professional-demeanor-clean-minimalist-backdrop&width=600&height=700&seq=amelie-laurent-new-portrait&orientation=portrait"
                      : `https://readdy.ai/api/search-image?query=professional%20business%20executive%20portrait%20in%20modern%20office%20environment%20confident%20leader%20corporate%20photography%20high%20quality%20professional%20lighting%20clean%20background%20minimalist%20style&width=600&height=700&seq=testimonial-${testimonial.id}&orientation=portrait`
                    }
                    alt={testimonial.author}
                    width="600"
                    height="700"
                    loading="lazy"
                    decoding="async"
                    className="w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-500 will-change-[filter]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
